import { UpdateEcshopTradesAdditionsApi } from "@/features/accounts/ecshop/services/update-trades-additions-api";
import { UpdateEcshopTradesAdditionsRequestModel } from "@/features/accounts/ecshop/services/update-trades-additions-model";

/// その他連携サービス明細メモ・無効明細更新処理
export class UpdateEcshopTradesAdditionsService {
  private updateEcshopTradesAdditionsApi = new UpdateEcshopTradesAdditionsApi();

  /**
   * その他連携サービス明細メモ・無効明細更新API実行
   */
  public async updateEcshopTradesAdditions(param: UpdateEcshopTradesAdditionsRequestModel) {
    return await this.updateEcshopTradesAdditionsApi.updateEcshopTradesAdditions(param);
  }
}
